<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
================================================================================.vs-sidebar========== -->

<template>
  <div class="ps-sidebar-wrapper">
    <div class="ps-sidebar-holder">
      <switcher-app :launch-path="dash.launch_path" :icon="dash.icon" :page-names="dash.page_names" :name="dash.name" />

      <slide-y-up-transition group tag="div">
        <!--- GET APPS FROM API --->
        <div v-for="(app, index) in apps" :key="index">
          <switcher-app :launch-path="app.launch_path" :icon="app.icon" :page-names="app.page_names" :name="app.name" />
        </div>
      </slide-y-up-transition>
    </div>
  </div>
</template>

<script>
import SwitcherApp from './components/SwitcherApp'

export default {
  data () {
    return {
      apps: [],
      dash: {
        icon: 'https://cdn.discordapp.com/attachments/980915525116891217/980929206361923644/Home_PFP.png',
        name: 'Dashboard',
        page_names: ['dashboard'],
        launch_path: '/dashboard'
      }
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    },
    reduceButton: {
      get () {
        return this.$store.state.reduceButton
      },
      set (val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
      }
    }
  },
  watch: {
    'activeCourseInfo.id' () {
      this.initSwitcher()
    }
  },
  components: {
    SwitcherApp
  },
  methods: {
    initSwitcher () {
      this.fetchAppsList()
    },
    fetchAppsList () {
      const loadApps = []

      this.$http
        .get('app/platform/apps')
        .then((response) => {
          if (response.status === 200) {
            response.data.data.forEach((app) => {
              loadApps.push(app)
            })
            this.loadApps(loadApps)
          }
        })
        .catch(() => {
          this.loadApps(loadApps)
        })
    },
    loadApps (apps) {
      this.apps = []
      apps.forEach((app, index) => {
        setTimeout(() => {
          this.apps.push(app)
        }, index * 60)
      })
    }
  },
  beforeMount () {
    this.initSwitcher()
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/vuexy/components/platformSwitcher.scss';
</style>
